import(/* webpackMode: "eager" */ "/src/src/app/[variants]/(staitc-page)/packaging/packaging.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
